const state = {
  orderInfo: null,
  // 优惠券信息
  couponInfo: {}
};

// mutations
const mutations = {
  setOrderInfo(stat, val) {
    stat.orderInfo = val;
  },
  setCouponInfo(stat, val) {
    stat.couponInfo = val;
  }
};

// actions
const actions = {};

export default {
  state,
  actions,
  mutations
};
